import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import z from "zod";

import { CreateClientRequest, createClientRequestSchema } from "~/api/clients/types";
import { restPoster } from "~/api/fetchers";
import { zStringToDate } from "~/utilities/zodInputHelpers";

const duplicateClientsObjectSchema = z.object({
  id: z.number(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().optional(),
  currentStatus: z
    .object({
      id: z.number(),
      active: z.boolean(),
      patientId: z.number(),
      clinicId: z.number(),
      created: zStringToDate(),
    })
    .optional(),
  clinicId: z.number().optional(),
  dateOfBirth: z.string().optional(),
  medicalServiceId: z.string().optional(),
  selfUpdatedLast: z.boolean(),
  created: zStringToDate(),
  accessControl: z.array(z.unknown()).optional(),
  restricted: z.boolean(),
  clientId: z.string(),
  accessLevel: z.string(),
  addresses: z.array(z.unknown()).optional(),
  sid: z.string(),
  securePatientId: z.number(),
  groupingKey: z.number().optional(),
});
export type DuplicateClient = z.infer<typeof duplicateClientsObjectSchema>;

const duplicateClientsResponse = z.array(duplicateClientsObjectSchema);

export type DuplicateClientsResponse = z.infer<typeof duplicateClientsResponse>;

/**
 * @deprecated Replace with the useInviteClientMutation below
 */
export function useDuplicateClientsQuery(
  enabled: boolean,
  variables: CreateClientRequest,
  options: Omit<UseQueryOptions<unknown, unknown, DuplicateClientsResponse>, "queryKey"> = {}
) {
  return useQuery<unknown, unknown, DuplicateClientsResponse>({
    queryKey: [DUPLICATE_CLIENT_ENDPOINT, variables],
    queryFn: async () => {
      const resp = await restPoster(
        `/v1/${DUPLICATE_CLIENT_ENDPOINT}`,
        createClientRequestSchema.parse(variables)
      );
      return duplicateClientsResponse.parse(resp);
    },
    enabled,
    staleTime: Infinity,
    ...options,
  });
}
const DUPLICATE_CLIENT_ENDPOINT = "clients/duplicates";
useDuplicateClientsQuery.getKey = () => [DUPLICATE_CLIENT_ENDPOINT];

export const checkClientDuplicatesMutation = {
  mutationFn: async (variables: CreateClientRequest) => {
    const response = await restPoster(
      `/v1/clients/duplicates`,
      createClientRequestSchema.parse(variables)
    );
    return duplicateClientsResponse.parse(response);
  },
};
